import { Data } from '../../apis/digital-process.model';
import {
	ApplicantName,
	ApplicantType,
	PreApplicationState,
} from '../../state/pre-application.model';

export const mapFromPreApplicationStateFrom = (
	data: Data
): PreApplicationState => {
	return {
		periodicityId: data.id_periodicidad ?? 0,
		preApplicationId: data.id_presolicitud ?? 0,
		folio: data.folioDigital ?? null,
		amount: data.monto_necesidad ?? 0,
		rate: data.tasa,
		subProductId: data.id_subproducto ?? 1,
		creditTerm: data.plazo ?? 0,
		periodPayment: data.plazo,
		applicantType: getApplicantType(data.id_tipo_persona),
		applicantId: data.numero ?? 0,
		applicantName: getApplicantName(
			data.nombre_s,
			data.apellido_paterno,
			data.apellido_materno
		),
		applicantPhone: data.celular ?? '',
		applicantBirthDate: data.fecha_nacimiento ?? '',
		isApplicantAMember:
			getApplicantType(data.id_tipo_persona) === ApplicantType.MEMBER,
		isCreditApproved:
			data.id_estatus_solicitud > 1 && data.id_estatus_solicitud < 4,
		authorizedAmount: data.monto ?? 0,
		cat: 0,
		email: data.correo ?? '',
		otpCode: '',
		applicationId: data.id_solicitud ?? 0,
		applicantAmountSelected: data.monto ?? 0,
		totalAmountToPay: 0,
		productId: 0,
		productName: '',
		segmentId: 0,
		isSocialContributionApplicable: false,
		schoolarshipCertificateId: 0,
		curp: data.curp,
		tdcApplicationId: data.id_solicitud_tdc ?? 0,
		applicantAddresses: [],
		applicationStatus: data.id_estatus_solicitud ?? 0,
		applicationSubStatus: data.sub_status_solicitud ?? 0,
		preApplicationStatus: data.id_estatus_presolicitud ?? 0,
		productCobisId: data.codigo_producto_core ?? '',
	};
};

export const getApplicantType = (personType: number): ApplicantType => {
	switch (personType) {
		case 1:
			return ApplicantType.MEMBER;
		case 2:
			return ApplicantType.LEAD;
		default:
			return ApplicantType.LEAD;
	}
};

const getApplicantName = (
	name: string,
	firstSurname: string,
	secondSurname: string
): ApplicantName => {
	return {
		name,
		firstSurname,
		secondSurname,
	};
};
